import { render, staticRenderFns } from "./ShopDetails.vue?vue&type=template&id=17b1873f"
import script from "./ShopDetails.vue?vue&type=script&lang=js"
export * from "./ShopDetails.vue?vue&type=script&lang=js"
import style0 from "./ShopDetails.vue?vue&type=style&index=0&id=17b1873f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports